import React from "react";
import Collumn from "./collumn";

export default class Board extends React.Component {
	renderCollumn(i) {
		return <Collumn cells={this.props.collumns[i]} onClick={() => this.props.onClick(i)} />;
	}

	render() {
		return (
			<div id="board">
				{this.renderCollumn(0)}
				{this.renderCollumn(1)}
				{this.renderCollumn(2)}
				{this.renderCollumn(3)}
				{this.renderCollumn(4)}
				{this.renderCollumn(5)}
				{this.renderCollumn(6)}
			</div>
		);
	}
}
